import type { SoftphoneKeypadProps } from './index.types';
import { SoftphoneDivider } from 'Modules/softphone/components/SoftphoneDivider';
import { useSoftphoneKeypad } from 'Modules/softphone/hooks';
import React from 'react';
import { cn } from '~/lib/utils';
import { SoftphoneOnCallHeader } from '../SoftphoneOnCallHeader';
import { KeypadGrid } from './KeypadGrid';
import { KeypadInput } from './KeypadInput';

/**
 * SoftphoneKeypad Component
 * Main keypad component for in-call DTMF input
 */
export const SoftphoneKeypad = ({
  className,
  testID,
  gridClassName,
}: SoftphoneKeypadProps): React.ReactElement => {
  const keypadTestId = testID ? `${testID}-keypad` : undefined;

  const { handleClose } = useSoftphoneKeypad();

  return (
    <section
      className={cn(
        'w-full flex flex-col items-center px-[16px] gap-[8px] mt-[4px]',
        className
      )}
      data-testid={keypadTestId}
      aria-label="In-call keypad"
    >
      <SoftphoneOnCallHeader testID={keypadTestId} onClose={handleClose} />

      <KeypadInput testID={keypadTestId} />

      <SoftphoneDivider testID={keypadTestId} />

      <KeypadGrid testID={keypadTestId} className={gridClassName} />
    </section>
  );
};
